import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBluelagoon, Bluelagoon } from "@bluelagoon";
import useWorkflowPreviewToken from "../hooks/useWorkflowPreviewToken";

export default function ClientAppIframe() {
    const { domain } = useParams();
    const { t } = useTranslation();
    const [workflowId, setWorkflowId] = useState(null);
    const [resolvedDomain, setResolvedDomain] = useState(null);
    const [error, setError] = useState(null);

    const { call: lookupWorkflow } = useBluelagoon({
        method: "getClientWorkflowByInternalDomain",
    });

    useEffect(() => {
        let cancelled = false;
        setWorkflowId(null);
        setResolvedDomain(null);
        setError(null);

        if (!domain) return undefined;

        lookupWorkflow({ internalDomain: domain })
            .then((payload) => {
                if (cancelled) return;
                const data = payload?.data || payload || {};
                if (!data.workflowId) {
                    setError("notFound");
                    return;
                }
                setWorkflowId(data.workflowId);
                setResolvedDomain(data.internalDomain || domain);
            })
            .catch((err) => {
                if (cancelled) return;
                const status = err?.response?.status;
                setError(status === 404 ? "notFound" : "loadFailed");
            });

        return () => {
            cancelled = true;
        };
    }, [domain, lookupWorkflow]);

    const { token: previewToken } = useWorkflowPreviewToken(workflowId);

    if (error) {
        return (
            <div className="w-full h-full flex items-center justify-center text-sm text-gray-600">
                {error === "notFound"
                    ? t("clientApp.notFound")
                    : t("clientApp.loadFailed")}
            </div>
        );
    }

    if (!workflowId || !previewToken || !resolvedDomain) {
        return (
            <div className="w-full h-full flex items-center justify-center text-sm text-gray-500">
                {t("common.loading")}
            </div>
        );
    }

    const { componentServerUrl } = Bluelagoon.getComponentServerUrl(
        resolvedDomain
    );
    const iframeUrl = `${componentServerUrl}?x_deep_link_token=${encodeURIComponent(
        previewToken
    )}`;

    return (
        <div className="w-full h-full">
            <iframe
                src={iframeUrl}
                className="w-full h-full border-0"
                title={t("clientApp.iframeTitle")}
                allow="accelerometer; autoplay; encrypted-media; fullscreen; gyroscope; picture-in-picture; clipboard-write"
            />
        </div>
    );
}
